export enum EAuthReground {
    COUNTRIES = 'countries',
    STATES = 'states',
    CITIES = 'cities',
    POB_COUNTRIES = 'POB.countries',
    POB_STATES = 'POB.states',
    POB_CITIES = 'POB.cities',
    PR_COUNTRIES = 'PR.countries',
    PR_STATES = 'PR.states',
    PR_CITIES = 'PR.cities',
    DYNAMIC_COUNTRIES = 'DYNAMIC_COUNTRIES',
    DYNAMIC_STATES = 'DYNAMIC_STATES',
    DYNAMIC_CITIES = 'DYNAMIC_CITIES',
}

export enum EUserRoles {
    ADMIN = 'ADMIN',
    CLIENT = 'CLIENT',
    SUPER_ADMIN = 'SUPER_ADMIN',
    EDUCATOR = 'EDUCATOR',
    INSPECTION = 'INSPECTION',
}

// permissions
export enum EAdminPermissions {
    LOGIN = 'LOGIN:SFMP:ADMIN',
}

export enum EClientPermissions {
    LOGIN = 'LOGIN:SFMP:CLIENT',
}

export enum EEducatorPermissions {
    LOGIN = 'LOGIN:SFMP:EDUCATOR',
}

export enum EMedicalPermissions {
    LOGIN = 'LOGIN:SFMP:MEDICAL',
}

export enum EInspectionPermissions {
    LOGIN = 'LOGIN:SFMP:INSPECTOR',
}

export enum EReportPermissions {
    LOGIN = 'LOGIN:SFMP:REPORT',
}

export enum EAdminReportPermissions {
    LOGIN = 'LOGIN:SFMP:REPORT-ADMIN',
}
